import { useAuth } from '~/support/composables/auth';

export default defineNuxtPlugin(() => {
  const { hasEntitlement, hasRole } = useAuth();

  return {
    provide: {
      hasEntitlement,
      hasRole,
    },
  };
});
